import { IOperadorDetalleRequest } from "../../Interfaces/auxiliar/IOperador";
import { ISearch } from "../../Interfaces/base/IBase";
import { Ifilter } from "../../Interfaces/filter";
import {
  IFilterEquipo,
  IFilterEquipoBySupervisor,
  ISuplenteAdd,
} from "../../Interfaces/IEquipo";
import {
  IAsignacionSupervisor,
  IComboPersona,
  IDataCreatePersona,
  IRequestCargaMasivaEquipoTrabajo,
  ITableFilterPersonas,
} from "../../Interfaces/IPersona";
import { fetchAdministracion, fetchIPERC } from "../http-common";

const urlEquipoTrabajo = "EquipoTrabajo";
const urlPersona = "Persona";
const urlEnrrolar = "Enrrolar";

const tablaPersona = (filter: {}) => {
  return fetchAdministracion.get(`Persona/Listar`, { params: filter });
};

const personaByID = (idPersona: string) => {
  return fetchAdministracion.get(`Persona/${idPersona}`);
};

const personaByUserId = (usuarioId: string) => {
  return fetchAdministracion.get(
    `Persona/PersonaPorUserId?usuarioId=${usuarioId}`
  );
};

const getSupervisores = (
  filter: Ifilter,
  controller = new AbortController()
) => {
  return fetchAdministracion.get(`${urlEquipoTrabajo}/Supervisores`, {
    signal: controller.signal,
    params: filter,
  });
};

const postSuplente = (model: ISuplenteAdd) => {
  return fetchAdministracion.post(`${urlEquipoTrabajo}/Suplente`, model);
};

const getSuplente = (filter: ISearch) => {
  return fetchAdministracion.get(`${urlPersona}/ListarPersonaMina`, {
    params: filter,
  });
};

const getEquipoPorSupervisor = (filter: IFilterEquipoBySupervisor) => {
  return fetchAdministracion.get(`${urlEquipoTrabajo}/PorSupervisor`, {
    params: filter,
  });
};
const getAllAreas = () => {
  return fetchAdministracion.get("Area");
};
const getSupervisoresCombo = (
  search: string,
  controller = new AbortController()
) => {
  return fetchAdministracion.get(
    `${urlEquipoTrabajo}/SupervisoresSSOMA?Search=${search}`,
    { signal: controller.signal }
  );
};
const supervisorPorPersonaId = (personaId: string) => {
  return fetchAdministracion.get(`${urlEquipoTrabajo}/Reporta/${personaId}`);
};

const getSupervisoresIPERCdigital = (search: string = "") => {
  return fetchAdministracion.get(
    `${urlEquipoTrabajo}/SupervisoresIPERCdigital?search=${search}`
  );
};

const asignarSupervisor = (data: IAsignacionSupervisor) => {
  return fetchAdministracion.post(
    `${urlEquipoTrabajo}/AsignarSupervisor`,
    data
  );
};

const postPersonas = (filter: ITableFilterPersonas) => {
  return fetchAdministracion.post(`Persona/ListarPersonasIpercDigital`, filter);
};

const UsuarioLogueado = () => {
  return fetchAdministracion.get(`Persona/DetalleUsuario`);
};

const ActualizarPersona = (data: {}) => {
  return fetchAdministracion.put(`${urlPersona}/Actualizar`, data);
};

const ObtenerEnroll = (data: string) => {
  return fetchIPERC.post(`${urlEnrrolar}/ObtenerEnroll`, { usuarioId: data });
};

const PersonaDetalle = (data: IOperadorDetalleRequest, controller = new AbortController()) => {
  return fetchAdministracion.get(`${urlPersona}/PersonaByCodigoSync`, {
    params: data,
    signal: controller.signal
  });
};

const CrearPersona = (command: IDataCreatePersona) => {
  return fetchAdministracion.post(`${urlPersona}/Agregar/PersonaBasico`, command);
};
const ComboPersona = (query: IComboPersona, controller = new AbortController()) => {
  return fetchAdministracion.post(`${urlPersona}/ComboFiltro`, query, {
    signal: controller.signal
  });
};

const CrearEquipoTrabajoMasivo = (request: IRequestCargaMasivaEquipoTrabajo) => {
  return fetchAdministracion.post(`${urlEquipoTrabajo}/CrearEquipoTrabajoMasivo`, request);
};


const personaServicio = {
  tablaPersona,
  personaByID,
  getSupervisores,
  postSuplente,
  getSuplente,
  getEquipoPorSupervisor,
  getAllAreas,
  getSupervisoresCombo,
  supervisorPorPersonaId,
  getSupervisoresIPERCdigital,
  asignarSupervisor,
  postPersonas,
  personaByUserId,
  UsuarioLogueado,
  ObtenerEnroll,
  ActualizarPersona,
  PersonaDetalle,
  CrearPersona,
  ComboPersona,
  CrearEquipoTrabajoMasivo,

};

export default personaServicio;
